import * as React from "react";
import BaseIcon from "../../BaseIcon";

export default class TopicProfileIcon extends BaseIcon {
    getChildren = () => [
        <g fill={this.getColor()} fillRule='evenodd'>
            <path d="M1.000,14.000 C0.448,14.000 -0.000,13.552 -0.000,13.000 L-0.000,1.000 C-0.000,0.447 0.448,-0.000 1.000,-0.000 L10.000,-0.000 C10.552,-0.000 11.000,0.447 11.000,1.000 L11.000,7.774 L4.774,14.000 L1.000,14.000 ZM9.000,2.000 L2.000,2.000 L2.000,5.000 L9.000,5.000 L9.000,2.000 ZM9.000,7.000 L2.000,7.000 L2.000,8.000 L9.000,8.000 L9.000,7.000 ZM9.000,9.000 L2.000,9.000 L2.000,10.000 L8.000,10.000 L9.000,9.000 ZM7.000,11.000 L2.000,11.000 L2.000,12.000 L6.000,12.000 L7.000,11.000 ZM10.999,13.938 L10.999,13.969 L6.945,14.006 L11.030,9.856 L10.999,13.938 Z" transform="translate(2.48 1)" />
        </g>
    ];
    getViewBox = () => "0 0 16 16";
}
